export function customizedCheckbox({ label, count, isRefined }) {
  return `
    <label class="custom-checkbox-wrapper d-flex align-items-center gap-2">
      <input type="checkbox" class="custom-checkbox-input" value="${label}" ${
        isRefined ? "checked" : ""
      } />
      <span class="custom-checkbox-box"></span>
      <span class="mx-2">${label}</span>
      <span class="badge rounded-pill bg-warning text-dark mx-1">${count}</span>
    </label>
  `;
}
